export default "__VITE_ASSET__CY2kk$a2__"